import { ManageChapters } from './ManageChapters'
import { withManageChapters } from './withManageChapters'

const ConnectedManageChapters = withManageChapters(ManageChapters)

export { ConnectedManageChapters as ManageChapters }
